import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useParams } from "react-router-dom"
import "./ClassSummary.scss"
import { selectIcon, SVG } from "../../components/UI/selector"
import UserSummaryCard from "./UserSummaryCard/UserSummaryCard"
import ApiURL from "../../services/ApiURL"
import { ActivitySummaryApi } from "../../services/CallApi"
import { CheckValue } from "../../services/CommonFunction"
import { DateWithFormatTable } from "../../components/ReusableComponents/Date/Date"

const ClassSummary = () => {
  const params = useParams()
  const { user_id } = useSelector((state) => state.profile.profileData)
  // eslint-disable-next-line
  const [currentRank, updateCurrentRank] = useState(0)
  // eslint-disable-next-line
  const [isOndemand, updateOndemandStatus] = useState(
    params.isOndemand === "true"
  )
  const [summaryData, updateSummaryData] = useState({
    name: null,
    first_name: "--",
    last_name: "--",
    thumb: selectIcon("userDummy"),
    activity_types: [],
    clubbedUsers: [],
    started_at: null,
    duration_in_minutes: 0,
  })

  useEffect(() => {
    if (CheckValue(user_id)) {
      getSummaryData(params)
    }
  }, [user_id])

  const getSummaryData = (params) => {
    const data = {
      activity_id: params.activityId,
      user_activity_session_id: params.userSessionId,
    }
    ActivitySummaryApi(ApiURL._classSummary, data, isOndemand).then((res) => {
      if (res.status) {
        const obj = res.list.clubbedUsers.find((el) => el.user_id === user_id)
        updateCurrentRank(CheckValue(obj) ? obj.rank : 0)
        updateSummaryData({ ...res.list })
      }
    })
  }

  const userSummaryCards = Object.keys(summaryData).length
    ? summaryData.clubbedUsers.map((el, index) => (
        <UserSummaryCard
          key={el.user_id}
          isOndemand={isOndemand}
          rank={isOndemand ? el.rank : index}
          me={el.user_id === user_id}
          {...el}
        />
      ))
    : []

  return summaryData.name ? (
    <div className="ClassSummary">
      <div className="SumarryStatsContainer">
        <div className="SummaryStatsDiv box-layer1">
          <img className="SummarryCoachImage" src={summaryData.thumb} />
          <div className="SummaryClassDetails">
            <p className="SummaryClassTitle">{summaryData.name}</p>
            <p className="SummaryCoachName">With {summaryData.first_name}</p>
            {summaryData.activity_types.length ? (
              <div className="SummaryTypeContainerDiv">
                <div className="SummaryTypeDiv">
                  <p>{summaryData.activity_types[0]}</p>
                </div>
                {summaryData.activity_types.length > 1 ? (
                  <div className="SummaryTypeDiv">
                    <p>{summaryData.activity_types.length - 1}</p>
                  </div>
                ) : null}
              </div>
            ) : null}
            {CheckValue(summaryData.started_at) ? (
              <div className="summaryDate">
                <div className="summaryDateTime">
                  <SVG src={selectIcon("watch")} />
                  <p>
                    <DateWithFormatTable
                      date={summaryData.started_at}
                      format={"MMM D, h:mm A"}
                    />
                  </p>
                </div>
                <div className="summaryDuration">
                  <SVG src={selectIcon("clock")} />
                  <p>{Math.round(summaryData.duration_in_minutes)} Mins</p>
                </div>
              </div>
            ) : null}
          </div>
        </div>
        <div
          className="SummaryStatsDiv box-layer1"
          style={{ justifyContent: "space-around" }}
        >
          <p className="SummaryStatsTitle">Total member in class :</p>
          <div className="SummaryStatsIconDiv">
            <div className="SummaryStatsIcon">
              <SVG
                className="summaryUsersIcon"
                src={selectIcon("memberIcon1")}
              />
            </div>
            <p>{summaryData.clubbedUsers.length}</p>
          </div>
        </div>
      </div>
      <p className="SummaryCardsContainerTitle">PARTICIPANTS</p>
      <div className="SummaryCardsContainer box-layer1">
        {/* ======== userSummaryCards ============= */}
        {userSummaryCards}
        {/* ======== userSummaryCards ============= */}
      </div>
    </div>
  ) : null
}

export default ClassSummary
